// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentActionStyles$ReactHooksTemplate = require("./ImportEnrichmentActionStyles.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");

function ImportEnrichmentTemplateBuilder(props) {
  var onChange = props.onChange;
  var fieldOptions = props.fieldOptions;
  var templateText = props.templateText;
  var textareaRef = React.useRef(null);
  var readableFields = ImportEnrichmentFieldOptions$ReactHooksTemplate.flatReadableOptions(fieldOptions);
  var preview = ImportEnrichmentActionHelpers$ReactHooksTemplate.templateHumanPreview(fieldOptions, templateText);
  var invalidPaths = ImportEnrichmentActionHelpers$ReactHooksTemplate.templateInvalidPaths(fieldOptions, templateText);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Combined text",
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                    }),
                JsxRuntime.jsx("textarea", {
                      ref: Caml_option.some(textareaRef),
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase + " min-h-24",
                      placeholder: "Type your message here, then insert fields where needed.",
                      value: templateText,
                      onChange: (function (e) {
                          Curry._1(onChange, e.target.value);
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Insert field",
                              className: "text-xs font-medium text-gray-600 mb-1 block"
                            }),
                        JsxRuntime.jsxs("select", {
                              children: [
                                JsxRuntime.jsx("option", {
                                      children: "Choose a field to insert at cursor…",
                                      value: ""
                                    }),
                                Belt_Array.map(readableFields, (function (field) {
                                        return JsxRuntime.jsx("option", {
                                                    children: field.label,
                                                    value: field.path
                                                  }, field.path);
                                      }))
                              ],
                              className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase + " text-xs",
                              value: "",
                              onChange: (function (e) {
                                  var path = e.target.value;
                                  if (path === "") {
                                    return ;
                                  }
                                  var token = "\${" + path + "}";
                                  var element = textareaRef.current;
                                  if (element == null) {
                                    return Curry._1(onChange, templateText === "" ? token : templateText + " " + token);
                                  }
                                  var start = ((el) => typeof el.selectionStart === "number" ? el.selectionStart : el.value.length)(element);
                                  var end = ((el) => typeof el.selectionEnd === "number" ? el.selectionEnd : el.value.length)(element);
                                  var before = templateText.substring(0, start);
                                  var after = templateText.substring(end, templateText.length);
                                  Curry._1(onChange, before + token + after);
                                })
                            })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Readable preview",
                              className: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1"
                            }),
                        JsxRuntime.jsx("p", {
                              children: preview,
                              className: "text-sm text-gray-800 leading-snug"
                            })
                      ],
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.previewBoxClass
                    }),
                Belt_List.length(invalidPaths) > 0 ? JsxRuntime.jsx("p", {
                        children: "Some inserted fields are no longer available in the catalog. Review before saving.",
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.validationWarningClass
                      }) : null,
                JsxRuntime.jsx("p", {
                      children: "Example: Hello [Customer Name], your policy [Policy Number] has expired.",
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                    })
              ],
              className: "space-y-3"
            });
}

var make = ImportEnrichmentTemplateBuilder;

exports.make = make;
/* react Not a pure module */
